module.exports = __webpack_public_path__ + "fonts/flag_poland.svg";